'use strict';

// Import Libraries
import React from 'react';

const targetWords = ['of', 'cm', 'mm', 'sq', 'in', 'ft', 'oz', 'lb', 'gsm', 'x'],
  specialCase = ['RSVP', 'NBA', 'NFL', 'NHL', 'MBA', 'MLB'];

const wordMatch = word => {
  return targetWords.some(function(targetWord) {
    return word.toLowerCase() === targetWord.toLowerCase();
  });
};

const wordMatchSpecialCase = word => {
  return specialCase.some(function(specialWord) {
    return word.toLowerCase() === specialWord.toLowerCase();
  });
};

const changeWord = (word, i) => {
  if (wordMatch(word)) {
    return (
      <span className="text-lowercase" key={i} data-test-id="lowercase">
        {word}
      </span>
    );
  } else if (wordMatchSpecialCase(word)) {
    return (
      <span className="text-uppercase" key={i} data-test-id="uppercase">
        {word}
      </span>
    );
  } else {
    return word;
  }
};

const DecapitalisedTitle = ({ children: words }) => {
  if (typeof words !== 'string') {
    return words;
  }

  const result = [];

  words.split(' ').forEach(function(word, i, array) {
    result.push(changeWord(word, i));

    if (i < array.length - 1) {
      result.push(' ');
    }
  });

  return <span>{result}</span>;
};

export default DecapitalisedTitle;
